var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "11px",
    viewBox: "0 0 10 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Calendar/10x10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03a-Dashboard---Default",
    transform: "translate(-556.000000, -115.000000)",
    fill: "current"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(551.083826, 113.118644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(4.916174, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Calendar/10x10",
    transform: "translate(0.000000, 2.205811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.423,5.679 L4.105,5.679 L4.105,3.139 L1.423,3.139 L1.423,5.679 Z M7.66,1.569 L7.66,0.471 C7.66,0.211 7.449,0 7.188,0 L6.33,0 C6.07,0 5.859,0.211 5.859,0.471 L5.859,1.569 L4.126,1.569 L4.126,0.471 C4.126,0.211 3.915,0 3.655,0 L2.797,0 C2.537,0 2.326,0.211 2.326,0.471 L2.326,1.569 L0,1.569 L0,9.976 L9.985,9.976 L9.985,1.569 L7.66,1.569 Z",
    id: "Fill-1"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.3fb6028229efdfd35bc6bad3bbeea7a3.svg";
export { ForwardRef as ReactComponent };